import { createAction, props } from '@ngrx/store';
import { Notification } from './notifications.models';
import { QueryResult, QueryParams } from '../../core/store/models';

export const loadUnreadNotifications = createAction('[Notifications] Load Unread Notifications', props<{ params: QueryParams }>());
export const loadUnreadNotificationsComplete = createAction(
  '[Notifications] Load Unread Notifications Complete',
  props<{ data: QueryResult<Notification> }>()
);

export const addUnreadNotification = createAction('[Notifications] Add Unread Notification', props<{ notification: Notification }>());
export const dismissHoverNotification = createAction(
  '[Notifications] Dismiss Hover Notification',
  props<{ uId: string; markRead?: boolean }>()
);
export const dismissHoverNotificationComplete = createAction(
  '[Notifications] Dismiss Hover Notification Complete',
  props<{ uId: string; markRead?: boolean }>()
);
export const clearNotification = createAction('[Notifications/API] Clear Notification', props<{ uId: string }>());
export const clearTransientNotification = createAction(
  '[Notifications/API] Clear Transient Notification',
  props<{ uId: string }>()
);

export const clearAllNotifications = createAction('[Notifications/API] Clear All Notifications', props<{ clearPermanent: boolean }>());
export const clearAllNotificationsComplete = createAction('[Notifications/API] Clear All Notifications Complete');

export const showNotifications = createAction('[Notifications/UI] Show Notifications');
export const hideNotifications = createAction('[Notifications/UI] Hide Notifications');
export const setError = createAction('[Notifications] Set Error', props<{ err: any }>());
